// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1cBJU","content":"LayoutSettings_content__281ey"};